import EmployeeGrowthComponent from '../EmployeeGrowthComponent.vue'
import BugTicketsView from '../BugTicketsView.vue'
import AdminGrowthComponent from '../admin/AdminGrowthComponent.vue'

export default [
  {
    path: '/employee-growth',
    name: 'EmployeeGrowth',
    meta: { layout: 'default' },
    component: EmployeeGrowthComponent,
  },
  {
    path: '/employee-growth-admin',
    name: 'EmployeeGrowthAdmin',
    meta: { layout: 'default', requiresRole: [1] },
    component: AdminGrowthComponent,
  },
  // Old URL, kept so existing bookmarks/links still land on the admin page
  { path: '/employee-growth/admin', redirect: { name: 'EmployeeGrowthAdmin' } },
  {
    path: '/employee-growth/bugs',
    name: 'EmployeeGrowthBugs',
    meta: { layout: 'default' },
    component: BugTicketsView,
  },
]
